export const FETCH_SERVER_CAPABILITY = 'V2/ServerCapability/Fetch'

export const fetchServerCapabilities = () => ({
    type: FETCH_SERVER_CAPABILITY,
    payload: ({ fetchForApplication }) => fetchForApplication('/server/capabilities'),
})
